const state = {
  travelContext: null,
};

const getters = {
  getTravelContext: (stateParam) => stateParam.travelContext,
};

const mutations = {
  setTravelContext(stateParam, data) {
    // eslint-disable-next-line no-param-reassign
    stateParam.travelContext = data;
  },
  clearTravelContext(stateParam) {
    // eslint-disable-next-line no-param-reassign
    stateParam.travelContext = null;
  },
};

const actions = {
  // Actions for payment processing if needed
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
